import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white" data-id="element-78">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-79">
        <div className="bg-stone-50 rounded-2xl p-8 md:p-12 border-2 border-dashed border-stone-200 flex flex-col md:flex-row items-center gap-8" data-id="element-80">
          <div className="flex-shrink-0" data-id="element-81">
            <div className="w-32 h-32 bg-amber-100 rounded-full flex items-center justify-center border-4 border-white shadow-lg" data-id="element-82">
              <ShieldCheck className="w-16 h-16 text-amber-600" data-id="element-83" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-84">
            <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4" data-id="element-85">
              The 7-Day "Better Jeans" Guarantee
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed" data-id="element-86">
              I am so confident this ritual works that I’m taking all the risk.
              Download the guide, try the tonic, and do the 5-minute ritual for
              7 days. If your jeans don't feel looser and your energy isn't
              higher, just send me an email and I’ll refund every penny. No
              questions asked.
            </p>
          </div>
        </div>
      </div>
    </section>;
}